<template>
    <main-layout class="min-h-dvh flex flex-col">
        <app-header class="bg-gradient-to-b from-secondary to-primary pb-8"></app-header>

        <nav class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-[1.5rem] relative z-20 isolate shadow-xl -mt-6 px-2 flex-1 overflow-y-auto">

            <!-- Chargement -->
            <div v-if="loading" class="w-full h-[calc(100vh-180px)] rounded-b-3xl shadow-md grid place-items-center">
                <span class="text-primary/70">Chargement du support…</span>
            </div>

            <!-- Erreur -->
            <div v-else-if="error" class="w-full h-[calc(100vh-180px)] rounded-b-3xl shadow-md grid place-items-center">
                <div class="text-center px-6">
                    <p class="text-red-600 font-semibold mb-2">Impossible d’ouvrir le support</p>
                    <p class="text-primary/70 mb-4">Aucun token n’a été trouvé pour cet utilisateur.</p>
                    <router-link to="/home" class="underline text-primary">Retour à l’accueil</router-link>
                </div>
            </div>

            <!-- Iframe object -->
            <object v-else id="supportObject" type="text/html" :data="supportUrl"
                class="w-full h-[calc(100vh-200px)] rounded-b-3xl shadow-md"></object>
        </nav>
    </main-layout>
</template>

<script>
export default {
    name: "SupportPage",
    data() {
        return {
            loading: true,
            error: false,
            supportUrl: "",
        };
    },
    async mounted() {
        try {
            const profil = JSON.parse(await localforage.getItem("profil"));

            const token = profil.operator.token;

            const uid = profil.uid;
            if (!token) throw new Error("Token manquant");

            this.supportUrl =
                "https://support.fi360.fr/public/list?token=" +
                encodeURIComponent(token) +
                "&user=" + uid;
            this.loading = false;
        } catch (e) {
            this.loading = false;
            this.error = true;
        }
    },
    methods: {
        handleClose() {
            if (window.history.length > 1) this.$router.back();
            else this.$router.push("/home");
        },
    },
};
</script>



// WEBPACK FOOTER //
// Support.vue?21240e0e